import { useLocation } from "react-router-dom"
import ErrorPage from "../../components/ErrorPage"
import { userStore } from "../../store/userStore"
import { hrefForCurrentCinema } from "../../lib/cinemaSlugs"

export default function Forbidden() {
    const location = useLocation()
    const user = userStore(s => s.user)
    const isAuthed = Boolean(user?.token)

    return (
        <ErrorPage
            code="403"
            accentColor="#e4206b"
            illustration="forbidden"
            stickers={[
                { label: "вход закрыт 🔒", color: "#e4206b", rotate: -2 },
                { label: "только для своих 🚫", color: "#349be6", rotate: 2 },
                { label: "без билета 🎟", color: "#29cc6a", rotate: -1 },
            ]}
            title={
                <>
                    Сюда <span style={{ color: "#e4206b" }}>нельзя</span>
                </>
            }
            description="У вас нет доступа к этой зоне — как в закрытый зал без билета. Войдите в аккаунт или вернитесь на главную."
            marquee={["доступ запрещён", "нужна авторизация", "закрытый зал", "войдите в аккаунт"]}
            primaryAction={
                isAuthed
                    ? { label: "На главную", to: "/" }
                    : {
                          label: "Войти",
                          to: "/auth",
                          state: { backgroundLocation: location },
                      }
            }
            secondaryAction={
                isAuthed
                    ? { label: "К афише", to: hrefForCurrentCinema("/afisha") }
                    : { label: "На главную", to: "/" }
            }
        />
    )
}
